import { Sidebar } from '../components/sidebar';
import { ThinSidebar } from '../components/thinSidebar';
import { VideoGrid } from '../components/videoGrid';
import { Component, onIframeLoad } from '../helpers/helper';
import { state } from '../state';
import { transport } from '../firebaseTransport';

export const Channel = Component(() => {
	function toggleCaptions() {
		transport
			.broadcast({ type: 'captions_enable', enable: !state.captions_enabled })
			.catch(err => console.error('captions_enable broadcast failed', err));
	}

	function toggleSpeech() {
		state.speech_enabled = !state.speech_enabled;
		if (state.speech_enabled) {
			let translateScript = document.createElement('script');
			translateScript.setAttribute(
				'src',
				'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit'
			);
			document.head.appendChild(translateScript);
		}
	}

	return () => (
		<div id="channel">
			<ThinSidebar></ThinSidebar>
			{state.expanded && <Sidebar></Sidebar>}
			<div id="main_content">
				{state.videoLayout === 'gallery' && <VideoGrid />}

				{state.videoLayout !== 'gallery' && state.showVideo && (
					<div id="videoContainer">
						{state.mainVideoStream && (
							<video class={{ flip: state.mirrorVideo }} srcObject={state.mainVideoStream} autoplay></video>
						)}
					</div>
				)}

				<iframe
					onLoad={onIframeLoad}
					id="app-frame"
					src={state.appUrl}
					style={{ display: state.showApp ? 'block' : 'none' }}
					allow="fullscreen ; microphone ; camera ; geolocation ; midi ; encrypted-media ; autoplay "
				></iframe>

				{state.loadingChannel && <div id="noAppLoadedMessage">Loading Channel..</div>}

				{!state.loadingChannel && !state.showApp && !state.mainVideoStream && state.videoLayout !== 'gallery' && (
					<div id="noAppLoadedMessage">
						<a onClick={e => state.browseApps()}>Select App</a>
					</div>
				)}
			</div>
		</div>
	);
});
